import useNavigation from './useNavigation';

interface IParams {
  equipment_id?: string;
}

export default function useEquipmentDashboardNavigation() {
  return useNavigation<IParams>('/equipment-dashboard');
}
